import { type PropsWithChildren } from "react"
import { CommunicationPreferencesFields } from "./CommunicationPreferencesFields"
import { CommunicationPreferencesTitle } from "./CommunicationPreferencesTitle"

export function CommunicationPreferences({ children }: PropsWithChildren) {
    return <>{children}</>
}

CommunicationPreferences.Title = CommunicationPreferencesTitle
CommunicationPreferences.Fields = CommunicationPreferencesFields
